export default __webpack_public_path__ + "70a992287198c6c8fd3d0454d3304bfe.png";